import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
} from "recharts";
import { ShoppingBag, Star, Activity } from "lucide-react";
import MetricCard from "./MetricCard";

const data = [
  { name: "Jan", traffic: 300, duration: 290 },
  { name: "Feb", traffic: 280, duration: 260 },
  { name: "Mar", traffic: 250, duration: 240 },
  { name: "Apr", traffic: 220, duration: 200 },
  { name: "May", traffic: 210, duration: 190 },
  { name: "Jun", traffic: 220, duration: 210 },
  { name: "Jul", traffic: 240, duration: 230 },
  { name: "Aug", traffic: 250, duration: 240 },
  { name: "Sep", traffic: 270, duration: 260 },
  { name: "Oct", traffic: 290, duration: 280 },
  { name: "Nov", traffic: 280, duration: 270 },
  { name: "Dec", traffic: 260, duration: 250 },
];

const metrics = [
  { id: 1, title: "Products", value: 70, icon: ShoppingBag, color: "danger" },
  { id: 2, title: "Satisfaction", value: 59, icon: Star, color: "warning" },
  { id: 3, title: "Sales", value: 65, icon: Activity, color: "success" },
];

const EngagementChart = () => {
  return (
    <div className="card" style={{ border: "none", outline: "none" }}>
      <div className="card-body">
        <h5 className="card-title">Engagement Analysis</h5>

        <div style={{ height: "200px", width: "100%" }} className="mt-5">
          <ResponsiveContainer width="100%" height="100%">
            <LineChart
              data={data}
              margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Line
                type="monotone"
                dataKey="traffic"
                stroke="#000000"
                strokeWidth={2}
                dot={false}
                name="Average monthly traffic"
              />
              <Line
                type="monotone"
                dataKey="duration"
                stroke="#ff0000"
                strokeWidth={2}
                dot={false}
                name="Average visit duration"
              />
            </LineChart>
          </ResponsiveContainer>
        </div>

        <div className="d-flex justify-content-center gap-5 mt-4 mb-4">
          <div>
            <div className="small text-muted">Average monthly traffic</div>
            <div className="fw-bold">184,000 visits</div>
          </div>
          <div>
            <div className="small text-muted">Average visit duration</div>
            <div className="fw-bold">163.8 seconds</div>
          </div>
        </div>

        <div className="row g-3">
          {metrics.map((metric) => (
            <div key={metric.id} className="col-md-4">
              <MetricCard
                title={metric.title}
                value={metric.value}
                icon={metric.icon}
                color={metric.color}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default EngagementChart;
